import { css } from "@emotion/react";

import { COLORS, HELPERS } from "styles-js";

export const acceptAllCheckbox = css`
    font-size: 14px;
    letter-spacing: 1px;
    color: ${COLORS.primary};
    font-weight: 800;
`;

export const infoField = css`
    font-size: 12px;
    margin-bottom: 30px;
`;

export const submitButton = css`

${HELPERS.media.smallerThan.sm} {
        margin-top: 0px;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        box-shadow: 0 -1px 3px 3px rgba(40, 72, 103, 0.2);
        z-index:11;
      }
`;
